var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"justify-center align-center mb-6"},[_c('youtube',{ref:"youtube",attrs:{"video-id":_vm.$youtube.getIdFromUrl(_vm.filterValue(_vm.item.videoId)),"player-vars":{ autoplay: 1 },"width":"100%"}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.fixWordpressUrl(_vm.filterValue(_vm.item.desc))))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }